import {
  IBankTransaction,
  TGetTransactionDetailsData,
  TransactionDataTypeEnum,
  TransactionTypeEnum
} from '@/services/types/TransactionData';
import { TTransactionHistory } from '../../types/TransactionHistory';
import {
  getAccountTransferDetails,
  getAdminFeesDetails,
  getBankTransferIncomingDetails,
  getBankTransferOutgoingDetails,
  getEmergePayDetails,
  getInterestDetails,
  getInvestmentDetails,
  getPurchaseDetails,
  getTaxDetails,
  getTopUpDetails
} from '../../data/transactionHistoryDetails';
import { renderDetails } from './renderDetails';
import { AccountType } from '@/context/types/Account';

export const renderTransactionDrawerDetails = (
  accountType: AccountType,
  transaction: TTransactionHistory,
  transactionDetails: TGetTransactionDetailsData
) => {
  // Use the raw transaction details that has the last update
  transaction.details = transactionDetails;

  return getTransactionDetails(accountType, transaction).map((detail, index) =>
    renderDetails(detail, index, transaction.data.id)
  );
};

const getTransactionDetails = (accountType: AccountType, transaction: TTransactionHistory) => {
  switch (transaction.type) {
    case TransactionTypeEnum.Purchase:
      return getPurchaseDetails(accountType, transaction);
    case TransactionTypeEnum.Bank: {
      const bankTransactionDetails = transaction.data as IBankTransaction;

      if (bankTransactionDetails.type === TransactionDataTypeEnum.Incoming) {
        return getBankTransferIncomingDetails(accountType, transaction);
      }

      return getBankTransferOutgoingDetails(accountType, transaction);
    }
    case TransactionTypeEnum.Transfer:
      return getAccountTransferDetails(accountType, transaction);
    case TransactionTypeEnum.Admin:
      return getAdminFeesDetails(accountType, transaction);

    case TransactionTypeEnum.TopUp:
      return getTopUpDetails(accountType, transaction);
    case TransactionTypeEnum.EmergePay:
      return getEmergePayDetails(accountType, transaction);
    case TransactionTypeEnum.Interest:
    case TransactionTypeEnum.Return:
      return getInterestDetails(accountType, transaction);
    case TransactionTypeEnum.Tax:
      return getTaxDetails(accountType, transaction);
    case TransactionTypeEnum.Investment:
      return getInvestmentDetails(accountType, transaction);
  }
};
